/**
 * ViewToggle Component
 *
 * Toggle between grid and list view modes for product display.
 * Persists preference to localStorage via useViewMode hook.
 */

export type ViewMode = 'grid' | 'list';

interface ViewToggleProps {
  mode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export function ViewToggle({ mode, onChange }: ViewToggleProps) {
  return (
    <div className="inline-flex items-center gap-1 p-1 bg-neutral-900 border border-neutral-800 rounded-lg">
      <button
        onClick={() => onChange('grid')}
        className={`p-2 rounded transition-colors ${
          mode === 'grid'
            ? 'bg-neutral-800 text-white'
            : 'text-neutral-500 hover:text-white'
        }`}
        aria-label="Grid view"
        aria-pressed={mode === 'grid'}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
      </button>
      <button
        onClick={() => onChange('list')}
        className={`p-2 rounded transition-colors ${
          mode === 'list'
            ? 'bg-neutral-800 text-white'
            : 'text-neutral-500 hover:text-white'
        }`}
        aria-label="List view"
        aria-pressed={mode === 'list'}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>
    </div>
  );
}
